import { IServiceResult, IStore, ITerritory, IUser } from "../Models/Models";

export interface IUserManagementAxios {
  GetUserFranchiseeStoreInformation(
    userID: number
  ): Promise<IServiceResult<Array<IStore>>>;
  GetUserFranchiseeTerritoryInformation(
    userID: number
  ): Promise<IServiceResult<Array<ITerritory>>>;
  RemoveStoreFromFranchiseeUser(
    userID: number,
    storeID: number
  ): Promise<IServiceResult<boolean>>;
  RemoveTerritoryFromFranchiseeUser(
    userID: number,
    territoryID: number
  ): Promise<IServiceResult<boolean>>;
  UpdateUserActiveStatus(
    userID: number,
    activeStatus: boolean
  ): Promise<IServiceResult<IUser>>;
  UpdateSessionTimeoutLength(
      companyId: number,
      newSessionTimeoutLength: number
  ) : Promise<IServiceResult<IUser>>;
}
